module.exports = __webpack_public_path__ + "src/images/clemson-university.422e85611662368a4f2406071cce3239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/clemson-university.jpg
// module id = 111
// module chunks = 0